import { render, staticRenderFns } from "./cmp.vue?vue&type=template&id=5c0a1963&scoped=true&lang=pug&"
var script = {}
import style0 from "./cmp.vue?vue&type=style&index=0&id=5c0a1963&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a1963",
  null
  
)

export default component.exports